import React from 'react';
import PropTypes from 'prop-types';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import { LocaleService } from '@sm360/widget-commons-core-services';
import ModelButton from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/YearsButtons/ModelButton/ModelButton.jsx';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/YearsButtons/YearsButtons.scss';

const YearsButtons = ({ years, handleChange, resetSettings }) => {
    const title = LocaleService.t('FILTERS.YEARS');
    const clearTxt = LocaleService.t('BUTTONS.CLEAR');

    return (
        <div className="listing-used-filters-bloc listing-used-filters-bodystyle">
            <div className="listing-button-wrapper">
                <div className="listing-used-filters-title sr-text is-bold">
                    {title}
                    <button className="listing-used-filters-clear sr-link is-regular" onClick={resetSettings}>
                        {clearTxt}
                    </button>
                </div>
                {years.map((year) => {
                    const yearNumber = year.get('label');
                    return (
                        <ModelButton
                            value={yearNumber}
                            key={yearNumber}
                            handleChange={handleChange}
                            isSelected={year.get('isSelected')}
                            count={year.get('count')}
                        />
                    );
                })}
            </div>
        </div>
    );
};

YearsButtons.defaultProps = {
    years: [],
};

YearsButtons.propTypes = {
    years: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    handleChange: PropTypes.func.isRequired,
    resetSettings: PropTypes.func.isRequired,
};

YearsButtons.displayName = 'YearsButtons';

export default YearsButtons;
